import { ThisReceiver } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { AuthorityOptsDocument } from 'src/app/shared/models/AuthorityOptsDocument';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
@Component({
  selector: 'app-security-option-transaction',
  templateUrl: './security-option-transaction.component.html',
  styleUrls: ['./security-option-transaction.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class SecurityOptionTransactionComponent implements OnInit {


  nvLAllGuides: boolean = false;

  blocked: boolean = false;
  lstAuthOpts: AuthorityOptsDocument[];
  selectedAuthOpts: AuthorityOptsDocument;
  loading: boolean = true;
  documentDialog: boolean;
  submitted: boolean;

  fctnCoord: boolean;
  fctnSecretary: boolean;
  fctnTreasure: boolean;
  fctnMaterial: boolean;
  fctnYoungs: boolean;
  fctnschoolPG: boolean;

  nvlSupplier: boolean;
  nvlZonal: boolean;
  nvlNational: boolean;
  nvlLocal: boolean;
  onMant : boolean;

  disabledGuideId: boolean = false;
  disabledStoreId: boolean = false;

  documentAuthOpts: AuthorityOptsDocument;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private tovpilUtils: TovpilUtilsService,
    private apiService: ApiService) {

  }

  ngOnInit(): void {
    this.loadLstAutOpt();

  }


  loadLstAutOpt() {
    this.apiService.getAllAuthorityOpts().then(
      data => {
        this.lstAuthOpts = data;
        this.loading = false;
      });

  }

  openNew() {
    this.documentAuthOpts = {};
    this.submitted = false;
    this.documentDialog = true;
  }

  editDocument(documentAuthOpts: AuthorityOptsDocument) {
    this.documentAuthOpts = { ...documentAuthOpts };
    this.fctnCoord = this.tovpilUtils.booleanify(documentAuthOpts.coordinator);
    this.fctnSecretary = this.tovpilUtils.booleanify(documentAuthOpts.secretary);
    this.fctnTreasure = this.tovpilUtils.booleanify(documentAuthOpts.treasurer);
    this.fctnMaterial = this.tovpilUtils.booleanify(documentAuthOpts.materials);
    this.fctnYoungs = this.tovpilUtils.booleanify(documentAuthOpts.youngs);
    this.fctnschoolPG = this.tovpilUtils.booleanify(documentAuthOpts.schoolPG);
    this.nvlSupplier = this.tovpilUtils.booleanify(documentAuthOpts.suppliers);
    this.nvlZonal = this.tovpilUtils.booleanify(documentAuthOpts.zoneLevel);
    this.nvlNational = this.tovpilUtils.booleanify(documentAuthOpts.natioLevel);
    this.nvlLocal = this.tovpilUtils.booleanify(documentAuthOpts.localLevel);
    this.onMant = this.tovpilUtils.booleanify(documentAuthOpts.onMaint);
    if (!this.fctnCoord && !this.fctnSecretary && !this.fctnTreasure && !this.fctnMaterial && !this.fctnYoungs && !this.fctnschoolPG && !this.nvlSupplier && !this.nvlZonal && !this.nvlNational && !this.nvlLocal && !this.onMant) {
      this.nvLAllGuides = true;
    } else {
      this.nvLAllGuides = false;
    }

    this.documentDialog = true;
  }

  hideDialog() {
    this.documentDialog = false;
    this.submitted = false;
    this.fctnCoord = this.fctnSecretary = this.fctnTreasure =
      this.fctnMaterial = this.fctnYoungs = this.fctnschoolPG =
      this.nvlSupplier = this.nvlZonal = this.nvlNational =
      this.nvlLocal = this.onMant = false;

  }

  async saveDocument() {
    this.submitted = true;

    if (this.nvLAllGuides) {
      this.fctnCoord = false;
      this.fctnSecretary = false;
      this.fctnTreasure = false;
      this.fctnMaterial = false;
      this.fctnYoungs = false;
      this.fctnschoolPG = false;
      this.nvlSupplier = false;
      this.nvlZonal = false;
      this.nvlNational = false;
      this.nvlLocal = false;
      this.onMant = false;
      this.documentAuthOpts.guideId='';
      this.documentAuthOpts.storeId='';
      this.nvlSupplier=false;
    }

    this.documentAuthOpts.coordinator = this.tovpilUtils.booleanToString(this.fctnCoord);
    this.documentAuthOpts.secretary = this.tovpilUtils.booleanToString(this.fctnSecretary);
    this.documentAuthOpts.treasurer = this.tovpilUtils.booleanToString(this.fctnTreasure);
    this.documentAuthOpts.materials = this.tovpilUtils.booleanToString(this.fctnMaterial);
    this.documentAuthOpts.youngs = this.tovpilUtils.booleanToString(this.fctnYoungs);
    this.documentAuthOpts.schoolPG = this.tovpilUtils.booleanToString(this.fctnschoolPG);
    this.documentAuthOpts.suppliers = this.tovpilUtils.booleanToString(this.nvlSupplier);
    this.documentAuthOpts.zoneLevel = this.tovpilUtils.booleanToString(this.nvlZonal);
    this.documentAuthOpts.natioLevel = this.tovpilUtils.booleanToString(this.nvlNational);
    this.documentAuthOpts.localLevel = this.tovpilUtils.booleanToString(this.nvlLocal);
    this.documentAuthOpts.onMaint = this.tovpilUtils.booleanToString(this.onMant);

    if (this.documentAuthOpts.transactionId) {
      if (this.documentAuthOpts.id) {
        await this.apiService.updateAuthorityOpts(this.documentAuthOpts).then(
          data => {
            this.documentAuthOpts = data;
            this.loading = false;
            //this.lstAuthOpts[this.findIndexById(this.documentAuthOpts.id)] = this.documentAuthOpts;
            this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Document Updated', life: 3000 });
          });

      }
      else {
        await this.apiService.createAuthorityOpts(this.documentAuthOpts).then(
          data => {
            this.documentAuthOpts = data;
            this.loading = false;
            //this.lstAuthOpts.push(this.documentAuthOpts);
            this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Document Created', life: 3000 });
          });
      }

      //this.lstAuthOpts = [...this.lstAuthOpts];
      this.documentAuthOpts = {};
      await this.loadLstAutOpt();
      this.hideDialog();
    }
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.lstAuthOpts.length; i++) {
      if (this.lstAuthOpts[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  }
  goBack(){
    window.close();
  }
}
